<template>
  <ckeditor v-model="text" :config="config" @input="$emit('input', this.text)"></ckeditor>
</template>

<script>
export default {
  data: () => ({
    text: null,
  }),
  mounted() {
    this.text = this.value;
  },
  props: {
    value: String,
    config: {
      type: Object,
      default: () => ({
        filebrowserUploadUrl: "./api/upload",
        toolbarGroups: [
          { name: "clipboard", groups: ["clipboard", "undo"] },
          { name: "editing", groups: ["find", "selection"] },
          { name: "links" },
          { name: "insert" },
          { name: "forms" },
          { name: "tools" },
          { name: "document", groups: ["mode", "document", "doctools"] },
          { name: "others" },
          "/",
          { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
          },
          { name: "styles" },
          { name: "colors" },
        ],
      }),
    },
  },
};
</script>

<style>
</style>